import { WeeklyInsightResponse } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL;

if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required but not configured');
}

class InsightsApiService {
  private readonly baseUrl = `${API_BASE_URL}/insights`;

  private async makeAuthenticatedRequest<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };

    const stored = localStorage.getItem('auth-store');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const token = parsed.state?.token;
        if (token) headers['Authorization'] = `Bearer ${token}`;
      } catch {
        // ignore parse errors
      }
    }

    const response = await fetch(endpoint, { ...options, headers: { ...headers, ...options.headers } });

    if (!response.ok) {
      let message = `HTTP ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        message = errorData.message || errorData.Message || message;
      } catch {
        // ignore json parse failure
      }
      throw new Error(message);
    }

    return response.json() as Promise<T>;
  }

  async getWeeklyInsights(): Promise<WeeklyInsightResponse> {
    return this.makeAuthenticatedRequest<WeeklyInsightResponse>(`${this.baseUrl}/weekly`);
  }

  async generateWeeklyInsights(): Promise<WeeklyInsightResponse> {
    return this.makeAuthenticatedRequest<WeeklyInsightResponse>(
      `${this.baseUrl}/weekly/generate`,
      { method: 'POST' }
    );
  }
}

export const insightsApiService = new InsightsApiService();
